import { Box, Checkbox, FormControlLabel, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAllergensQuery } from "../../types";
import { canSelectAllergenFree, effectiveAllergens, RecipeAllergenFormState } from "../Recipe/Form/allergens";
import { AllergenPicker } from "./AllergenPicker";

interface AllergenFormSectionProps {
  state: RecipeAllergenFormState;
  unavailableTooltipKey: "allergenFree.unavailableTooltip" | "allergenFree.unavailableTooltipMenuItem";
  onChangeSelfAllergens: (selfAllergens: string[]) => void;
  onChangeAllergenFree: (allergenFree: boolean) => void;
  disabled?: boolean;
}

export const AllergenFormSection = ({
  state,
  unavailableTooltipKey,
  onChangeSelfAllergens,
  onChangeAllergenFree,
  disabled,
}: AllergenFormSectionProps) => {
  const { t } = useTranslation();
  const { data } = useAllergensQuery();

  const allergenFreeAvailable = canSelectAllergenFree(state);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <AllergenPicker
        options={data?.allergens ?? []}
        value={effectiveAllergens(state)}
        readOnlyValue={state.inheritedAllergens}
        disabled={disabled}
        onChange={keys => onChangeSelfAllergens(keys.filter(key => !state.inheritedAllergens.includes(key)))}
      />
      <Tooltip title={allergenFreeAvailable ? "" : t(unavailableTooltipKey)}>
        <Box component="span" sx={{ alignSelf: "flex-start" }}>
          <FormControlLabel
            label={t("allergenFree.label")}
            control={
              <Checkbox
                checked={state.allergenFree && allergenFreeAvailable}
                disabled={disabled || !allergenFreeAvailable}
                onChange={event => onChangeAllergenFree(event.target.checked)}
              />
            }
          />
        </Box>
      </Tooltip>
    </Box>
  );
};
